import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("en-AU", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

const BlogTeaser = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/blog`)
      .then((res) => setPosts(res.data.slice(0, 3)))
      .catch(() => {});
  }, []);

  if (!posts.length) return null;

  return (
    <section id="journal" data-testid="blog-teaser-section" className="bg-sage py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <SectionHead
            dark
            overline="From the blog"
            title={
              <>
                Teeth talk,{" "}
                <span className="italic text-fern">minus the jargon.</span>
              </>
            }
          />
          <Reveal delay={0.15}>
            <Link
              to="/blog"
              data-testid="blog-view-all-link"
              className="group inline-flex items-center gap-2 font-sans text-sm font-medium text-ink transition-colors hover:text-leafdeep"
            >
              Read all posts
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
          {posts.map((p, i) => (
            <Reveal key={p.slug} delay={0.1 * i} y={24}>
              <Link
                to={`/blog/${p.slug}`}
                data-testid="blog-article-card"
                className="group flex h-full flex-col overflow-hidden rounded-2xl border border-ink/8 bg-white shadow-[0_2px_20px_-8px_rgba(18,26,21,0.1)] transition-[box-shadow,transform] duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_-16px_rgba(18,26,21,0.25)]"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute left-4 top-4 rounded-full bg-forest/80 px-3 py-1 font-mono text-xs tracking-[0.25em] uppercase text-leaf backdrop-blur">
                    {p.category}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-7">
                  <h3 className="font-serif text-xl leading-snug text-ink transition-colors duration-300 group-hover:text-leafdeep">
                    {p.title}
                  </h3>
                  <p className="mt-3 flex-1 font-sans text-sm leading-relaxed text-fern">{p.excerpt}</p>
                  <p className="mt-5 font-mono text-xs tracking-[0.2em] uppercase text-fern/70">
                    {formatDate(p.date)} · {p.read_time}
                  </p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogTeaser;
